import React from 'react';
import PropTypes from 'prop-types';
import styles from './RadioBtn.module.scss';

const RadioBtn = ({checked, disabled, clickHandler, btnContainerOverrideClasses, btnDotOverrideClasses, ...props}) => {

    const onClickHandler = disabled ? () => null : clickHandler;
    const classes = [styles.customRadioBtnContainer].concat(btnContainerOverrideClasses);
    if (disabled) classes.push(styles.customRadioBtnDisabled);
    if (checked) classes.push(styles.customRadioBtnChecked);

    return (
        <div className={classes.join(' ')}
             onClick={onClickHandler}>
            {checked ? <div className={btnDotOverrideClasses.concat(styles.dotInside).join(' ')}/> : null}
        </div>
    );
};

RadioBtn.propTypes = {
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    clickHandler: PropTypes.func,
    btnContainerOverrideClasses: PropTypes.array,
    btnDotOverrideClasses: PropTypes.array,

};

RadioBtn.defaultProps = {
    disabled: false,
    checked: false,
    clickHandler: () => null,
    btnContainerOverrideClasses: [],
    btnDotOverrideClasses: [],
};

export default RadioBtn;
